<template>
  <div class="card-container">
    <common-top-form
      :selectShow="false"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      :show="true"
      addShowPower="/apppointssign/add"
    >
    </common-top-form>
    <common-table
      :data="tableData"
      :isShow="false"
      ref="commonTable"
      @handleChange="getPage"
    >
      <el-table-column
        prop="dayNumber"
        label="天数"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="money"
        label="积分"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/apppointssign/caozuo')"
        label="操作"
        min-width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="openAddDialog(scope.row)"
            >修改
          </el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="439px"
    >
      <el-form-item label="天数" prop="dayNumber">
        <el-input-number
          v-model="dialogModel.dayNumber"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="积分" prop="money">
        <el-input-number
          v-model="dialogModel.money"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import TransactionService from "service/TransactionService";

import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "apppointssign",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      show: false,
      formModel: {},
      tableData: [],
      submitService: TransactionService.apppointssignList,
      itemId: "",
      dialogModel: {
        dayNumber: undefined,
        money: undefined,
      },
      dialogRules: {
        dayNumber: [
          {
            required: true,
            message: "请输入",
          },
        ],
        money: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      isFlag: false,
      currentTypes: {},
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      this.params = {};
      return this.params;
    },
    dialogData() {
      const params = {
        dayNumber: this.dialogModel.dayNumber,
        money: this.dialogModel.money,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      console.log(params);
      return params;
    },
    dialogService() {
      return this.itemId
        ? TransactionService.apppointssignEdit
        : TransactionService.apppointssignInsert;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {};
      this.formModel = {};
      this.getList();
    },
    getPage() {
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        TransactionService.apppointssignDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        dayNumber: undefined,
        money: undefined,
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/AppPointsSign.vue